import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import type { DownloadService, FileData } from '@exiftrator/shared';

export function createDownloadService(): DownloadService {
  return {
    async downloadSingle(fileData: FileData): Promise<void> {
      // Normalize to an ArrayBuffer-backed view for BlobPart compatibility across TS lib versions.
      const normalizedBuffer = new Uint8Array(fileData.buffer);
      const blob = new Blob([normalizedBuffer], { type: fileData.mimeType || 'image/jpeg' });
      saveAs(blob, fileData.name);
    },

    async downloadMultiple(filesData: FileData[]): Promise<void> {
      const zip = new JSZip();

      for (const fileData of filesData) {
        zip.file(fileData.name, fileData.buffer);
      }

      const zipBlob = await zip.generateAsync({ type: 'blob' });
      saveAs(zipBlob, `metadata-edited-${Date.now()}.zip`);
    },
  };
}
